export { default as StrategyInfoSection } from './StrategyInfoSection';
